module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Two Steps Back")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I bet myself a dollar that he’d pull a picture out of his wallet within fifteen seconds of introducing himself. I only won fifty cents from that wager: He pulled it from his jacket pocket instead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Eden? I’m Gary. This is my little girl. Her name’s Casey.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She was beautiful,” I replied, contradicting his verb choice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If he noticed, he didn’t bother to correct me. “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man thumbed at the photograph in a sad sham of removing a smudge. He dug the pads of his thumbs into the glossy the way they all do—as if, should he rub hard enough, he might thrust his way through and find flesh beneath the paper.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s been over a year.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sorry, Gary.” I’d learned it was best if I began apologizing early on in these conversations. Things sometimes went more smoothly if they’d grown accustomed to hearing it by the time I had to break their hearts.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Gary put the picture down on the round, marble-top table ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("between us and smoothed it with his palm. “No, I’m sorry. You were just trying to have a cup of coffee and I’m bothering you.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I put my mug down and closed my book. “It’s okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I guess you get this a lot, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah,” I admitted. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("And it never gets any easier.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He dragged his attention away from the photo. At least he looked me in the eyes when he said the next part. “I was hoping you could help. Is there any way you could talk to her for me? I just want to know she’s all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sometimes they don’t ask so directly. Sometimes they’re so torn between being desperate and being ashamed that they stare at their hands, or at the floor. It’s all they can do to mumble their plea, and they often try to phrase it as though they can’t imagine I might say yes in a million years…because God knows they don’t believe in that sort of thing, anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But just in case, they have to ask.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I would be…” I stalled, and started again. “I would love to help you, but I don’t think I can. And it’s not because I don’t want to, because I do. But—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He cut me off there, and he lifted a brown satchel into his lap. “Oh, I know you need information, and I’ve brought it. I’ve got all the newspaper clippings from her kidnapping, and I’ve got the follow-up articles about the guy who did it; and I don’t know how this works exactly, so I brought some of her things for you to touch if that helps.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gary—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve got her first tooth, too.” Out from the bag he lifted a blue plastic container on a cord. “She got a dollar for it. It’s clean, don’t worry. It’s a couple of years old now. Here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I didn’t object fast enough. He clasped my hand in his and the tiny pebble tooth toppled down. I closed my fingers to keep from dropping it.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let me try to explain, please. I need for you to understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded hard, nearly shaking his glasses loose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I took a deep breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“One time, when I was in high school, we had a new guy join our class. The teacher made him stand up and tell everyone who he was and where he was from. His name was Jake, as it turns out, and he’d transferred to our school from Texas.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This one girl sitting behind him got all excited when she heard the ‘Texas’ part. When he sat down, she poked him on the shoulder and told him, ‘I’ve got a cousin who lives in Texas. Her name is Amy Abernathy. Do you know her?’ And everyone laughed at her.” I stopped there, seeing if he’d pick up the prompt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I bet they did. That was a pretty stupid question.” Gary fidgeted and picked up his daughter’s picture, fussing with it again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, under different circumstances it might not have been so dumb. Say, maybe her cousin mentioned someone with the same name as the new guy. It would be a coincidence if it turned out they knew each other, but it wouldn’t be a miracle or anything. Right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Right,” he said, but his heart wasn’t in the agreement. I think he knew where I was headed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or maybe if she was from another country, and she didn’t understand that Texas is a huge place with millions of people in it—then it wouldn’t be such a crazy question for her to ask either. Maybe, for all she knew, Texas was no bigger than a city block.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But it is. Much bigger.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, it is.” I put the little tooth back into its case and pushed the case back to Gary’s side of the table. “Do you get what I mean?”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tapped a fingernail at the tooth case for a few seconds, trying to decide how best to argue. “But being dead isn’t like being in Texas,” he finally said, and I could hear stubbornness working its way into his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re right, it’s not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then why won’t you try to talk to Casey for me?” He said the words slowly; he needed time to fortify each consonant against whatever I might say next.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gary, if Casey were in Texas, I would know where to begin looking for her. I could drive out there—I could look her up in the phone book. But imagine, for a second, that she could be anywhere at all in the entire world. But wherever she is, there aren’t any phones, and no matter how loud I shout, she won’t hear me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Eden—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And for that matter, there’s a better-than-average chance that she’s not even here anymore. Listen—when most people die, they don’t hang around. I don’t know where they go, and I don’t know how far away it is, but it’s someplace that’s…well, it’s not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("here.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("some")]), _vm._v(" of them stay. You know they do. You’ve seen them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, some of them do. And the ones who do are free to make contact with me if they like, but I don’t have the foggiest idea how to bring them around. Do you understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Clearly, he did not. “But you could "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("try.")]), _vm._v(" You could ask around, or something. If you really wanted to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Ask around? Gary, now we’re right back to the Texas analogy. Let me ask you something, and I am asking in all seriousness—without any intention of making fun of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go ahead.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“Have you prayed to Casey at all? And I’m using the word ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("‘pray’ in the very broadest sense—I mean, have you tried to talk to her yourself?” I already knew he had. Of course he had. They always do. I think it’s part of the “bargaining” stage of grief.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wouldn’t say I’ve been praying to her, but I’ve asked…if she might come have a word with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you’ve never heard, or felt, or seen anything to indicate she heard you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. But that’s why I came to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I took another deep breath, and then a third. I was getting frustrated with this poor man, and I knew that we were coming to a point in our conversation where he was only going to try my patience more. “Why would it be different if I tried to call her? You’re her father, and I’m a total stranger. I don’t believe that she could hear me any better than she can hear you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you could see her if she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" come. Couldn’t you? And I can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think that probably, yes, I could see her if she answered you. But I also think that you’d get some sense of her presence too. Or maybe not, I don’t know. What I’m trying to tell you is this, Gary: Unless she’s standing beside you right this second, there’s no way at all for me to communicate with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He dropped the tooth container into his satchel and clutched the picture with both hands. “She isn’t, then? She’s not here with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I could have fed him a line about how she was always with him in his heart, but such a trite sentiment would have only made us both angry. He wanted to know if his daughter was with him still—in a literal, if intangible, sense. We both knew the answer already, but someone had to say it out loud. That was the real reason he’d tracked me down.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("I tried to say it gently. “If Casey were still here and she knew ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("you were trying to reach her, she’d stay close to you. She was a daddy’s girl, right?” It was an easy guess.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh yes.” He was crying now, fat and quiet tears.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I pushed my napkin against his knuckles, and he took it. “And if she needed something, or if she was in some kind of trouble, you’d be the go-to guy, wouldn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He pressed the napkin to his face and bobbed his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You said you came here because you wanted to know if she was all right. Well, I think it’s safe to assume that she is. If she wasn’t, she’d be trying to tell you. But she’s not trying to communicate, at least not that I can see.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The mug-sized square of ephemeral coffeehouse napkin proved no match for Gary’s grief, so I fumbled for my purse and managed to scare up a couple of proper tissues.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re not even going to try then, are you?” he sniffled, stuffing the picture back into his jacket pocket. “Is it because I didn’t offer you any money? I don’t have much but—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Money? I didn’t ask you for any money.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I felt like I was sitting in the front car of a roller coaster, and cresting that first big hump. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Here we go.")]), _vm._v(" Once money’s come up, there’s nothing I can say or do to keep the talk from plummeting downhill. This is always the hardest part, and it always makes me angry, because it hurts my feelings.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course you didn’t. Because then it would be extortion, wouldn’t it? That’s why all the TV commercials for the psychic lines say in the small print, ‘for entertainment purposes only.’ That way, if they’re wrong you can’t sue them. But you pretend to be the real thing—you’re like one of those escort service girls who acts like no money needs to change hands in order to get results. I get it. I see.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("Ah, now we were rolling. Which to get defensive about ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("first—the implication that I was a fraud, or the comparison to a hooker?")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And I know, I know. The man was in pain, and he came to me seeking some comfort. I should have forgiven him for his misdirected anger; I should have been tolerant of his agony, and forgiven his terrible manners for his loss. I should have tried to help him. For what it’s worth, I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" forgive him. And I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" tolerant. And I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" try to help him. Yet for all that, I was still just a lying whore because I wouldn’t tell the man what he wanted to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I folded my hands around my coffee cup and sat back in the ironwork chair. “First of all I have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("never,")]), _vm._v(" not even once, claimed to be a medium. On the contrary, I’ve spent the last year of my life hiding—rather unsuccessfully, it would seem—from people like you who want to assign me that title. And second, I wouldn’t take your money if you threw it at me. If I could help you, I would—and I’d do it for nothing. But I can’t. I’m sorry for your loss, but there’s nothing I can do for you. If you’re not okay with that, you need to leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stood to leave, still crying. Still grasping my tissues.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I exhaled my entire collection of deeply drawn breaths as the door closed behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Similar scenarios had played themselves out so frequently that I’d given up hope for a different ending. Sometimes it took longer for the bereaved to go from grief-stricken and vulnerable to wishing that I, personally, were dead, but the end result was always the same.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("And I don’t know how they find me—it’s not like I put an ad in the paper. Maybe they track me down through online rumors, or my name is written on a bathroom wall somewhere. I wonder sometimes what the gossip says. Does it mention me ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("by name? There has to be more to it than “Biracial Southern girl chats up dead people. Come visit the Scenic City and see if you can sucker her into a reading.”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If I could find it myself, I’d delete or wash away every word.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My coffee had gone tepid. I wandered over to the counter and talked someone into trashing it in the sink for me, then reclaimed the cup for a fresh hit of caffeine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Behind me, the glass door swooshed open again, and I heard the electric hum of a familiar wheelchair. As usual, the sound of the chair was shadowed closely by four paws clapping on the tile floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, Karl,” I said over my shoulder as I pumped myself a refill from the air pot on the counter. “And hey, Cowboy,” I added towards the shaggy brute beside him. I finished my top-off and reached for the creamer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karl joysticked himself up to me so that his floppy, feathered cowboy hat hovered beside my shoulder. His diligent sheltie sidekick assumed a politely seated position on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve sure got a way with people.” He grinned. “You make ’em cry faster than that Barbara Walters woman.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks. I think.” I grabbed a brown plastic stirring stick and swirled my beverage until it turned a uniform beige. I faced him then, leaning my rear against the counter. “And what brings you two old coots downtown today? Anything special?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just you, beautiful. I’ve got a weakness for brunettes, you know.” He winked and wiggled his graying mustache at me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And blondes. And redheads.” I reached down and tugged at the brim of his hat, winking back without any real mirth. “And I bet you say that to all the girls who chase people out of the shop in tears.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("His laugh was a rough, low sound that managed to carry a Southern accent even without any vowels. That man could ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("clear his throat in a thunderstorm and you’d be able to hear he was a local.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve got me there. But I mean it—I was hoping you’d be out and about. Join you at your table?” He and Cowboy were already halfway to Gary’s freshly vacated spot, and I wouldn’t have told him no anyway. Instead, I pulled the seat out to make room for his chair and kicked my purse under the table so Cowboy wouldn’t have to lie on it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You want some coffee?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Got some.” He waved a foam to-go cup with one hand and a newspaper with the other. “Have you looked at today’s paper?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not likely. Haven’t needed to line any litter boxes since this morning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He snorted, and Cowboy’s ears perked, then settled again. “Then I guess no one else has showed you yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Showed me what?” I asked as a matter of formality, but just as I’d known that Gary would have a photograph on him, I might have known that Karl would have a ghost story. If he hadn’t been holding the newspaper, I’d have guessed he’d come to me bearing a new bad joke. Not a dirty or off-color joke, just a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bad")]), _vm._v(" joke—one that would take at least ten minutes to wend its slow, painful way to a punch line.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This article about what happened at the battlefield over Decoration Day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I like Karl’s jokes better than his ghost stories, but it was nothing personal, and it had nothing to do with his easygoing narrative style. It’s like I said once before about there being no such thing as old news in the South. Likewise, there is no such thing as a private matter.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("On the Internet someplace there’s a list of things you’ll never hear a Southerner say. I’ve seen it, and I think it’s ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("funny—though I’d love to add in the phrase “But it was none of my business, so I didn’t ask.” News or a damn good story will always find its way out, so ever since the whole mess with Malachi I’ve been a lightning rod for spooky anecdotes.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All of that having been said, by the time Karl showed me the article I had heard no fewer than a dozen versions of the Decoration Day incident at the Chickamauga Battlefield.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The story made the rounds in the valley with a speed that would shame a wildfire. Of course it expanded with each retelling until the saga came to include a regiment of skeletal Union ghosts, a couple of soldierless spook horses, a bloody-headed drummer boy, and at least two bugling wraiths who foretold the imminent rebirth and rise of the Confederacy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So you had to understand my skepticism.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You just look right here—they hid it on the third page, but it made it in all the same.” Karl unfolded the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Times Free Press")]), _vm._v(" and sorted it out, seeking a certain picture and finding it. He bent the third page double, nudged my coffee cup out of the way, and pushed the paper forward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“‘No Leads Yet in the Disappearance of Ryan Boynton.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, not that one.” He tapped the paper, down below the headline I’d just read.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“‘Mystery at Battlefield Park,’” I tried again, and he approved. “Sounds like a Nancy Drew title.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He patted at the columns with two long, bony fingers. “Go on and read it. Look what it says about Decoration Day.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“‘The first unusual incident took place at a Sons of Confederate Veterans gathering, attended by nearly sixty people who claimed their picnic was visited by a ghost. According to eyewitnesses, the specter of a young soldier approached the group and tried to speak, but he seemed unable to communicate. Before he vanished, the ghost pointed at the woods.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“‘One witness, Edna-Anne Macomber, insists that the soldier bore a strong resemblance to her husband at the age of twenty—prompting speculation that the unexpected visitor may have been her husband’s great-uncle. “He had the same-shaped face, and the same way of standing. You could’ve knocked me over with a feather when I saw him there. He looked right at us,” Mrs. Macomber claims. “And he knew it too. That’s why he chose us, I think. He knew Evan when he saw him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“‘Jeremiah Macomber fought with the Deas Brigade for the 19th Alabama regiment. He died in the Battle of Chickamauga on the first day of fighting, September 19, 1863.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I put the paper down and shrugged. “That wouldn’t be too surprising, I guess. Maybe that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" what drew old Jeremiah out in the first place—he spotted the family resemblance.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karl got all excited. “You think it’s true? You think some old soldier crashed the picnic?” He shifted around in his chair and gripped the brim of his hat with glee.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t say it’d shock me.” I tried and failed to remember a few details from a long-ago school trip to the battlefield visitors’ center. “How many people died out there, anyway?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lot")]), _vm._v(".” He beamed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I should’ve paid better attention in history class. But we know that a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lot")]), _vm._v(" of people died under violent and painful circumstances. I’d be astounded if there "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("weren’t")]), _vm._v(" any ghosts out there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you don’t hear a lot of ghost stories about the battlefield. You get stories about Old Green Eyes instead.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah,” I said, though that fact was something I’d always found strange. Thousands and thousands of dead soldiers are buried in the park, and most of the scary stories passed around campfires were about a made-up monster instead of the logical legions of war dead.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karl must have been thinking the same thing. “There’s a couple of stories about the tower in that field, and there’s one or two about weeping widows roaming the grounds looking for their husbands; but for the most part Green Eyes gets all the good lines.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The villain always does.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that’s")]), _vm._v(" true. I wonder why?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tossed my head to the left in half a shrug. “I couldn’t tell you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you believe in him?” he asked, leaning forward. I’d given him an inch, and here he came chasing after me for a mile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A year or two before I might have said no, but I’d had my horizons broadened a bit since then. “I don’t know. I’ve talked to people who’d swear on their mothers’ graves they’d seen him, but that doesn’t mean anything. One of them was Mike, for God’s sake.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mike’s the one who got drunk and fell off the roof of the library?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s him,” I confirmed. “He was trying to prove he could rock-climb at three in the morning. He used to live out by the battlefield, in the subdivision on the other side of the train tracks. You know—there on the edge of the park. Mike and his brother have a million and one Green Eyes stories, but since most of them start off with a case of beer I’m not inclined to take them very seriously.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karl tapped the paper again. “But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v("—this looks like something you could sink your teeth into, doesn’t it? This is the sort of thing that you could maybe confirm, at least some of the little details.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("“Maybe.” I crooked my neck and examined the picture posted beside the story. The square black-and-white frame held a shot of a starry-eyed older woman with her arms crossed ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("beneath her breasts. Edna-Anne, I gathered, even before I checked the caption. “I wonder if there are any pictures of this Jeremiah guy? Something you could show people for comparison’s sake. If Edna-Anne could pull him out of a lineup, that’d be something.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There might be pictures, there might be. And if there are, you can bet Tripp and Dana will dig them up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I started to ask who he meant, but the answer dawned on me before I could broach the question. “The Gruesome Two-some? Are they coming here to look into this? Oh, good "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("grief.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?” He brushed his hand to his chest in pretended affront. Then he said exactly what I should have expected from someone who’d never left the valley. “But they’re "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("famous.")]), _vm._v(" And I hear that the people at the battlefield actually asked them to come out and look into this. Rumor has it, they’re going to bring all that fancy equipment and set up for a few nights. Taking pictures, and getting readings and things.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They must be working on another book.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dana and Tripp Marshall were such well-known ghost hunters that even I had heard of them. Their shtick had a one-two punch: She had left an engineering career with NASA, and he was a psychic who claimed to have worked for the FBI. Their first taste of notoriety came courtesy of an old episode of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unsolved Mysteries,")]), _vm._v(" and since then they’d made the rounds of every niche cable show and prime-time paranormal investigative special on the tube.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you ever read "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("They Speak from Beyond")]), _vm._v("? That thing scared the pants off of me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("“I missed that one,” I halfway lied. I had picked it up from a display in a bookstore and made it through a couple of chapters before putting it down. I didn’t like the feel of it; the authors ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("were trying so hard to sell the audience on the phenomenon that I wondered if they believed anything they were saying.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("People who already believe simply "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("know,")]), _vm._v(" and they don’t feel compelled to proselytize. People who "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("know")]), _vm._v(" tell their stories like Edna-Anne Macomber, with a simple certainty that doesn’t much mind if it’s mocked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But why would they come "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("here")]), _vm._v("?” I asked. “Famous ghost hunters with a Civil War fetish usually go to higher-publicity fields like Gettysburg or Manassas. We don’t have ghost stories at Chickamauga, remember? And Old Green Eyes, whatever he may be, isn’t usually good enough fodder for big shots like the Marshalls.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Finish the article.” He grinned like a maniac. “Something new is going on down there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Karl, nothing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("new")]), _vm._v(" has happened down there in a hundred years.” But even as I argued, I scanned for the place where I’d left off. “Well, all right. I stand corrected. ‘Since the Memorial Day incident last week, a dozen new sightings of pointing ghosts have been reported. Though descriptions vary, the encounters are all similar. Witnesses say that the ghosts either appear in front of them or approach them, and then point at a distant location before disappearing.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He barely let me finish. “You know what I heard? I heard that a couple of the park rangers were so freaked out they quit their jobs.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Did you hear this from the same source that told you the Marshalls were coming?” I asked, reading the dull concluding paragraph to myself and handing the paper back to him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("“No, I heard it elsewhere. My doctor’s son had an internship out there, and he dropped it yesterday because he was too scared to keep going to work. And one of the guys who works here”—he jerked his head towards the barista counter—“his ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("sister is married to one of the guys who keeps the grounds. I’m telling you, strange things are going on out there. You’ll see—they won’t be able to keep it page-three quiet for long, not at this rate. Before long, everyone’s going to know about it and they’re going to have to do something.”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I tried not to laugh, in case he would have taken it the wrong way. “And what precisely would you recommend that ‘they’ do, anyway? These guys are dead. There’s not a whole lot to threaten them with if they don’t want to leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not saying they should be threatened, my dear. But it sure would be nice if there was someone hanging around who could just walk up and ask them what they wanted. That’s all I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s what Tripp and Dana are for. Let the celebrities handle this one. I only talk to my own dearly departed kin, if I can help it.” I felt a damp tickle down near my ankle, and I nearly kicked with surprise. Cowboy was sniffing at my pants leg. I reached down and scratched at his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Woman, haven’t you got a curious bone in your body?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve got a couple hundred of them,” I assured him. “With change to spare.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then why not go on out there? Just take a look around and see what there is to see? You never know—you might be able to help those poor folks who can’t seem to rest.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I could have handed him one reason for each guilty, curious bone, but I only offered him the most pressing one. “That guy who was leaving when you came in a few minutes ago. Did you see him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, I did.” He said it with the exact same inflections as the speaker in the old Ray Stevens song about the streaker.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Didn’t look happy, did he?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No ma’am, he didn’t.”")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you know how he found me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karl shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Neither do I. But he’s the second one this month, and I’ve got to tell you, Karl, I really, really hate it when they find me. There’s nothing I can do for them, and feeling sorry for them only makes them mad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I found myself flailing for something to fidget with, and spotting my coffee stirrer, I picked it up. I twisted it around my index finger. “I don’t want any more weird presents of baby teeth, or friendship bracelets, or tiny lockets with a first snipping of hair. It’s awful—and it’s not getting any less awful as they keep on coming.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s probably a good thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“From a moral perspective, sure. But from a personal standpoint, it sucks—and I want it to stop. Or, at the very least, I’d like to keep it at a slow trickle. You don’t…” I paused to reconsider my phrasing. “You should see their faces. There’s this split second when they figure out all at once that I’m not going to tell them what they want to hear.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I swallowed, and stuffed the coffee stirrer into my mouth, pinching it between my teeth. “And you realize, don’t you, that if I were to get mixed up with these high-profile spook hunters, it would only get worse.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I get it. A whole lot worse, maybe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe.” We both sat quietly for a minute, him fussing with the paper’s corner and me nibbling the small brown straw down to a frayed, flattened bit of trash. “Sometimes I think maybe I ought to leave, and go someplace where people don’t know about me at all. It might be easier. Or better. I don’t know.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("He reached around the table and patted at my knee. “Aw, don’t say that. The brain-drain around here is bad enough; we don’t need all the beauty leaving the valley, too. But you know, ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("you wouldn’t have to get involved with those two old crazies if you didn’t want to. You could still poke around a little, see what’s up for yourself.”")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or for me, sure. You’re always welcome to go exploring for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me.")]), _vm._v(" I’d love to sneak on out there myself, but these days…” He stopped and caught himself before the words went slow or sad. He laughed instead, slapping at the arm of his chair. “These days I’d need one hell of an extension cord, wouldn’t I?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A cord, or a jet pack strapped to the back of that thing. You could run down Old Green Eyes and ask him yourself what’s going on out there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He laughed harder then, and Cowboy’s tail thumped an optimistic beat against my shin. “A jet pack! And maybe a couple of pairs of roller skates for Cowboy so I could pull him along behind me—but then again, he’d probably just ride in my lap like a big baby. You should’ve seen him at the Riverbend fireworks this year. He spent the whole thing with his nose buried under my arm. Oh, hang on—I’ve run dry. Let me grab a refill.” He took his foam cup in one hand and gripped the wheelchair’s joystick with the other and swiveled himself away from me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Despite the fact that Karl’s destination was less than six feet away, Cowboy took it upon himself to rise and dash after him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While Karl busied himself at the counter, pumping on the air pots, I fiddled with the newspaper. He was right, and it was a damn good story.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("I checked the last paragraph again and failed to see any mention of Tripp and Dana Marshall, so there was still hope that Karl’s sources had been incorrect on that final point. I didn’t have a solid reason to dislike the Marshalls so hard sight unseen, but that didn’t stop me. I hated the thought of them ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("coming to Chattanooga, bringing their cameras and spotlights and publicity crews.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Interacting with ghosts was something to be done quietly, and in private if possible—or so I liked to think. As awkwardly as I sometimes handled my strange abilities, I tried to take them seriously; and it made me uncomfortable to watch others treat my poorly guarded secret like a well-paying parlor trick.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then again, my reservations may have been as simple as an old-fashioned distrust of outsiders. But if rumor proved true and they were on their way, I would get my chance to see if my suspicion was warranted.")])])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page34"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fac24c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429939973_ch02.vue
// module id = 78
// module chunks = 0